import { observer } from 'mobx-react-lite';

import { IcBackIcon, IcView16Icon } from '@gem/icons';
import { Button, IconButton } from '@gem/ui-kit';

import styles from './styles.m.css';

const Header = ({ presenter }) => {
  return (
    <div className={styles.container}>
      <IconButton
        className={styles.close}
        Icon={IcBackIcon}
        onClick={presenter.onClose}
        size="big"
        iconSize="medium"
        theme="11"
      />
      {presenter.isStreamStarted && (
        <>
          <div className={styles.live}>LIVE</div>
          <Button
            size="0"
            rounding="1"
            theme="fixed-color"
            Icon={IcView16Icon}
            className={styles.viewers}
          >
            {presenter.viewersLiveCount}
          </Button>
        </>
      )}
    </div>
  );
};

export default observer(Header);
